import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';

import { ButtonTypes } from '@ed---interne/ng-uui-components';

import { emailValidator } from '../../../shared/validators/email.validator';
import { PasswordForgot } from '../../../core/states/auth.state';

@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false,
})
export class ForgotPasswordComponent {
    public ButtonTypes = ButtonTypes;

    public emailSentTo: string | undefined;

    public forgotPasswordFormGroup: FormGroup = this.formBuilder.group({
        email: ['', [emailValidator()]],
    });

    constructor(
        private readonly formBuilder: FormBuilder,
        private router: Router,
        private store: Store,
    ) {}

    public onSubmit(): void {
        this.passwordInit();
    }

    public async passwordInit() {
        const email = (this.emailSentTo || this.forgotPasswordFormGroup.value.email || '').trim();
        this.emailSentTo = email.toLowerCase();
        this.store.dispatch(
            new PasswordForgot({
                email: email,
            }),
        );
    }

    public send(): void {
        this.passwordInit();
        this.router.navigate(['/forgot-password']);
    }
}
